module.exports = __webpack_public_path__ + "img/vr.be232ddc.jpg";